<template>
	<div>
		<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<compFormEdit
				ref="formbase"
				align="center"
				class="margin-top-15"
				:formdata="getBase"
				v-model="formData"
			></compFormEdit>
			<footer slot="footer">
				<vButton theme="primary" class="margin-right-15" @click="submit">{{$t('fbb.fedex.calc_verify',{defaultValue:'开始验证'})}}</vButton>
				<vButton theme="error" class="margin-right-15" @click="reset">{{$t('global.common.btn_reset',{defaultValue:'重置'})}}</vButton>
			</footer>
		</compWrapper>
		<!-- <compWrapper title="验证结果" theme="info">
			<vFormItem labelWidth="120">验证结果:{{}}</vFormItem>
		</compWrapper>-->
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { HttpCheckAddress } from "@/service/fedex";
import mixin from './mixin'
export default {
	mixins: [mixin],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit")
	},
	data() {
		return {
			loading: false,
			formData: {
				country: "US"
			}
		};
	},
	computed: {
		getBase() {
			return [
				{
					label: this.$tc('global.common.country',1,{defaultValue:'国家'}),
					tag: "vSelect",
					key: "country",
					options: this.getCountryList
				},
				{
					label: this.$t('erp.b2c.state_province',{defaultValue:'州/省'}),
					key: "state",
				},
				{
					label: this.$t('erp.b2c.city',{defaultValue:'城市'}),
					key: "city",
				},
				{
					label: this.$t('erp.b2c.zip_code',{defaultValue:'邮编'}),
					key: "zip",
					formItem: {
						rules: {
							required: true,
							message: "该信息不能为空,请填写",
							// validator(rule, value, callback) {
							// 	if (!value || !/^[0-9]{5,}$/g.test(value)) {
							// 		callback(this.$t('fbb.fedex.receivecode_tip',{defaultValue:'该信息不能为空,且长度不能少于五位'}));
							// 	} else {
							// 		callback();
							// 	}
							// },
						},
					}
				},
				{
					label: this.$t('fbb.headlogistics.address_detail',{defaultValue:'详细地址'}),
					tag: "vTextarea",
					key: "street1"
				}
			];
		}
	},
	methods: {
		// reset() {
		// 	this.formData = {};
		// 	this.$refs.formbase.resetValidate();
		// },
		handleResult(data = "") {
			const addressMap = {
				"RESIDENTIAL": this.$t('fbb.fedex.address_per',{defaultValue:'住宅地址'}),
				"BUSINESS": this.$t('fbb.fedex.business_per',{defaultValue:'商业地址'}),
				"UNKNOWN": this.$t('fbb.fedex.unknown_per',{defaultValue:'未知地址'}),
				"MIXED": this.$t('fbb.fedex.mixed_address',{defaultValue:'商业、住宅混合地址'})
			},
				label = `${data} ${addressMap[data]}`;
			this.$VModal.warning({
				title: this.$t('fbb.fedex.verification_results',{defaultValue:'验证结果'}),
				showFooter: false,
				render(h, props) {
					return <div class="color-warning font-bold text-center padding-20 font-14">{label}</div>
				}
			})
		},
		async submit() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
			this.loading = true;
			HttpCheckAddress(this.formData).then(
				res => {
					this.handleResult(res.data);
					this.loading = false;
				},
				err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				}
			);
		}
	}
};
</script>
